export enum TransactionEntityType {
  Sale = 'SALE',
  WorkOrder = 'WORK_ORDER',
}

export enum TransactionClientType {
  Customer = 'CUSTOMER',
  Insurer = 'INSURER',
}

export enum TransactionAccreditor {
  TefElgin = 'TEF_ELGIN',
}

export enum TransactionPaymentType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  Pix = 'PIX',
}

export const TransactionPaymentTypeByTef: Record<
  'debito' | 'credito' | 'pix',
  TransactionPaymentType
> = {
  credito: TransactionPaymentType.Credit,
  debito: TransactionPaymentType.Debit,
  pix: TransactionPaymentType.Pix,
};

export interface PaymentTransactionRequest {
  entityType: TransactionEntityType;
  entityId: number;
  clientId?: number;
  clientType: TransactionClientType;
  companyId: number;
  documentTypeId: number;
  accreditor: TransactionAccreditor;
  code?: string;
  acquirerCnpj?: string;
  acquirerCode?: string;
  terminalNsu?: string;
  paymentType: TransactionPaymentType;
  uniqueId?: string;
  totalAmount: number;
  installmentQuantity: number;
  planAccountId: number;
  entityCode?: string;
  cardBrandName: string | undefined;
  authorizationCode: string | undefined;
}

export interface PaymentFinancialPendingRequest {
  entityType: TransactionEntityType;
  entityId?: number;
}

export enum PaymentFinancialPendingStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELED = 'CANCELED',
  CANCELLING = 'CANCELLING',
  CANCEL_FAILED = 'CANCEL_FAILED',
}

export interface PaymentFinancialPendingResponse {
  status: PaymentFinancialPendingStatus;
}

export interface PaymentTransactionCancelRequest {
  transactionId: number;
  planAccountId?: number;
  code: string;
}
